




import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator'

@Component
export default class FileInput extends Vue {
  @PropSync('base64', { type: String, default: '' })
  base64Sync!: string
  @PropSync('name', { type: String, default: '' })
  nameSync!: string
  @PropSync('title', { type: String, default: '' })
  titleSync!: string
  @PropSync('contentType', { type: String, default: '' })
  contentTypeSync!: string
  @Prop()
  value = false

  @Watch('value')
  selectFile() {
    if (this.value) {
      this.input.click()
      this.$emit('input', false)
    }
  }

  get input() {
    return this.$refs.input as HTMLInputElement
  }
  mounted() {
    const fileReader = new FileReader()
    fileReader.onload = e => {
      if (e.target) {
        this.base64Sync = e.target.result as string
      }
    }
    this.input.onchange = () => {
      if (this.input.files && this.input.files.length > 0) {
        const file = this.input.files[0]
        fileReader.readAsDataURL(file)
        this.nameSync = file.name
        if (!this.titleSync) {
          this.titleSync = file.name.split('.')[0]
        }
        this.contentTypeSync = file.type
      }
    }
  }
}
